<template>
  <div class="cbg-white-container">
    <div class="table-div">
      <table class="table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Message</th>
            <th>Attachment</th>
            <th>Created Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in listData" :key="index">
          <tr>
            <td>{{ item.userName }}</td>
            <td>{{ item.message }}</td>
            <td>
              <CButton
                size="sm"
                color="info"
                class="ml-1"
                @click="viewAffidavit(item)"
              >View Attachment</CButton>
            </td>
            <td>{{ item.createDate }}</td>
            <!-- <td>
              <v-btn class="btn btn-primary" @click="toggleDetails(item, index)">{{Boolean(item._toggled) ? 'Hide' : 'Show'}}</v-btn>
            </td>-->
          </tr>
          <!-- <tr>
            <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
              <CCardBody>
                  <CButton size="sm" color="info" class="ml-1" 
                    @click="viewAffidavit(item)">
                    View Affidavit
                  </CButton>
              </CCardBody>
            </CCollapse>
          </tr>-->
        </tbody>
      </table>
    </div>
    <CPagination
      align="end"
      :active-page.sync="currentPage"
      :pages="totalPage"
      @update:activePage="changePage"
    />
    <CModal
      :show.sync="affidavitModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      :details="affidavitData"
    >
      <CImg
        v-if="
          typeOfDocument == 'png' ||
            typeOfDocument == 'jpeg' ||
            typeOfDocument == 'jpg' ||
            typeOfDocument == 'webp'
        "
        :src="affidavitData"
        block
        class="mb-2"
        width="470"
        height="600"
      />
      <embed v-else-if="typeOfDocument == 'pdf'" :src="src" style="width: 100%;height:800px" />
      <template #header>
        <h6 class="modal-title">Affidavit</h6>
        <CButtonClose @click="affidavitModal = false" />
      </template>
      <template #footer>
        <CButton @click="affidavitModal = false" color="danger">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import config from "@/config.js";
import _ from "lodash";
export default {
  data() {
    return {
      dayJS,
      primaryModal: false,
      collaps: false,
      innerCollaps: false,
      dialogModal: false,
      details: [],
      collapseDuration: 0,
      listData: [],
      toggle: false,
      isCertificate: false,
      rejectModal: false,
      rejectData: {},
      rejectReason: "",
      infoData: {},
      affidavitModal: false,
      affidavitData: "",
      typeOfDocument: "",
      src: "",
      currentPage: 1,
      totalPage: 1,
      recordPerPage: 10,
      dayJS
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    validator(val) {
      return val ? val.length >= 2 : false;
    },
    toggleDetails(item, index) {
      this.$set(this.listData[index], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    changePage(currentPage, reduced) {
      this.currentPage = currentPage;
      this.list();
    },
    list() {
      let arr = [];
      let obj = {
        page: this.currentPage,
        record_per_page: this.recordPerPage
      };
      let url = `${config.BASE_URL}api/v2/admin/suggestion`;
      this.$http.post(url, obj).then(response => {
        if (response.body.status) {
          response.body.data.data.map(element => {
            arr.push({
              userName: element.sender.full_name,
              message: element.message,
              attachment: element.attachment,
              createDate: dayJS(element.create_date).format(
                "DD-MM-YYYY h:mm A"
              )
            });
          });
          this.listData = [...arr];
        }
      });
    },
    viewInfo(item) {
      this.infoData = item;
    },
    viewAffidavit(item) {
      // console.log('item', item);
      this.affidavitModal = true;
      let fileDetails = item && item.attachment[0].split(".");
      this.typeOfDocument = fileDetails[fileDetails.length - 1];
      this.src = item.attachment[0];
      this.affidavitData = item.attachment[0];
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  .btn-primary {
    color: #321fdb;
    background-color: transparent;
  }
  tr {
    &:last-child {
      td {
        border-bottom: 1px solid #d8dbe0;
      }
    }
  }
  thead {
    th {
      border-bottom: 1px solid #d8dbe0;
    }
  }

  th,
  td {
    width: 25%;
    &:last-child {
      text-align: right;
    }
  }
  .collaps-tr {
    th,
    td {
      width: 100%;
      &:last-child {
        text-align: left;
      }
    }
  }
}
</style>
